import { customizeError, getResponseData } from "../helpers/_functions";
import http from "../http-common";
import BaseService from "./base.service";

class Conge extends BaseService {
  constructor() {
    super("conges");
  }
  getWaitingConge(employeeId, category) {
    return http
      .get(`${this.path}/get-waiting/${employeeId}`, { params: { category } })
      .then((response) => getResponseData(response))
      .catch((err) => {
        return Promise.reject(customizeError(err));
      });
  }
  getTotalDecreaseValueSinceAnnualRenewal(holidayId, employeeId) {
    return http
      .get(`${this.path}/total-decrease-value/${holidayId}/${employeeId}`)
      .then((response) => getResponseData(response))
      .catch((err) => {
        return Promise.reject(customizeError(err));
      });
  }
  UpdateStatus(conge, { cancelToken = null } = {}) {
    return http.put(`${this.path}/updatestatus/${conge._id}`, conge, {
      cancelToken
    });
  }
  createVacations(conge, params = {}) {
    return http
      .post(`${this.path}/create`, conge, { params })
      .then((response) => getResponseData(response))
      .catch((err) => {
        return Promise.reject(customizeError(err));
      });
  }
  deleteConge(idConge, params = {}) {
    return http.delete(`${this.path}/delete/${idConge}`, { params });
  }
  getByEnterpriseAndFilter(idAdminEnterprise, params = {}, cancelToken = null) {
    return http
      .get(`${this.path}/enterpriseFilter/${idAdminEnterprise}`, {
        params,
        cancelToken
      })
      .then((response) => getResponseData(response))
      .catch((err) => {
        return Promise.reject(customizeError(err));
      });
  }

  getByEmployerAndFilter(employerId, params = {}) {
    return http
      .get(`${this.path}/employerFilter/${employerId}`, {
        params: { ...params, userId: employerId }
      })
      .then((response) => getResponseData(response))
      .catch((err) => {
        return Promise.reject(customizeError(err));
      });
  }
  updateRemainingDays(item) {
    return http.put(`${this.path}/updateRemainingDays/${item._id}`, item);
  }
  sendFilesToDocs(items) {
    return http.post(`${this.path}/send-files-to-docs`, items);
  }

  getCongesWithIndisponibilities(enterpriseId, params = {}) {
    return http
      .get(`${this.path}/list-with-indisponibilities/${enterpriseId}`, {
        params
      })
      .then((response) => getResponseData(response));
  }
}

export default new Conge();
